import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import Heading from "../../AdminComponents/Common/Heading";
import TextInput from "../../Components/Common/TextInput";
import CustomButton from "../../Components/Common/CustomButton";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Dropdown from "../../AdminComponents/Common/Dropdown";
import { BASE_URL } from "../../Assets/Constants";
import { category } from "../../Services/dymmyData";
import { toast } from "react-toastify";
import Calendar from "react-calendar/dist/cjs/Calendar.js";
import CloseIcon from "@mui/icons-material/Close";
import { theme } from "../../Assets/Theme/theme";

function CalendarCreation() {
  const navigate = useNavigate();
  const { state } = useLocation();

  console.log(state, "STATE");

  const { type } = useParams();
  const [inputValues, setInputValues] = useState({
    date: "",
    type: "",
    experience: "",
  });

  const today = new Date();

  const fiveYearsAgo = new Date(
    today.getFullYear() - 5,
    today.getMonth(),
    today.getDate()
  );

  const [adventureOptions, setAdventureOptions] = useState([]);
  const [errors, setErrors] = useState([]);
  const [generalError, setGeneralError] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [calendarView, setCalendarView] = useState("month");
  const [selectedDate, setSelectedDate] = useState();

  useEffect(() => {
    const fetchAdventures = async () => {
      const loginData = JSON.parse(localStorage.getItem("adminData"));
      const token = loginData?.token;

      if (!token) {
        toast.error("Authentication token is missing", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        navigate('/login')
        return;
      }

      try {
        const response = await axios.get(`${BASE_URL}/admin/experiences`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const adventures = response?.data?.data;

        console.log(adventures, "ADVVVV");


        if (!Array.isArray(adventures)) {
          throw new Error("Unexpected data format: adventures is not an array");
        }

        const types = adventures.map((item) => ({
          value: item?._id,
          label: item?.name,
        }));

        const uniqueTypes = types?.filter(
          (type, index, self) =>
            index === self.findIndex((t) => t.label === type?.label)
        );
        setAdventureOptions(types);
      } catch (error) {
        console.error("Error fetching adventure options:", error.message);
      }
    };

    fetchAdventures();
  }, []);

  useEffect(() => {
    setInputValues((prev) => ({
      ...prev,
      date: state?.date || today.toISOString().split("T")[0], 
      experience: state?.experienceId?._id || "",
    }));
  
    setSelectedDate(state?.date ? new Date(state.date) : today); 
  }, [state]);  

  const handleDateChange = (date) => {
    if (date < today) return; 
  
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    const formattedDate = localDate.toISOString().split("T")[0];
  
    setSelectedDate(date); 
    setInputValues((prev) => ({
      ...prev,
      date: formattedDate,
    }));
  
    handleClose();
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleAddDate = async () => {
    setErrors([]);
    const loginData = JSON.parse(localStorage.getItem("adminData"));
    const token = loginData?.token;

    if (!token) {
      toast.error("Authentication token is missing", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      navigate('/login')
      return;
    }

    const payload = {
      date: inputValues.date,
      experienceId: inputValues.experience
    };

    console.log(inputValues, "INPUT")


    setLoading(true)

    try {
      const response = await axios.post(
        `${BASE_URL}/admin/calender`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Date created successfully", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        style: { backgroundColor: 'orange', color: 'white' },
      });
      navigate(-1);
    } catch (error) {
      console.error("Error storing calendar:", error?.response?.data);
      setErrors(error?.response?.data?.errors || []);
      setGeneralError(error?.response?.data?.error);
    }
    finally {
      setLoading(false)
    }
  };

  const handleUpdateDate = async () => {
    setErrors([]);
    const loginData = JSON.parse(localStorage.getItem("adminData"));
    const token = loginData?.token;

    if (!token) {
      toast.error("Authentication token is missing", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      navigate('/login')
      return;
    }

    const payload = {
      date: inputValues.date,
      experienceId: inputValues.experience
    };

    setLoading(true)
    try {
      const response = await axios.put(
        `${BASE_URL}/admin/calender/${state?._id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Date updated successfully", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        style: { backgroundColor: 'orange', color: 'white' },
      });

      navigate(-1);
    } catch (error) {
      console.error("Error updating calendar:", error?.response);
      setGeneralError(error?.response?.data?.message);
      setErrors(error?.response?.data?.errors || []);
    } finally {
      setLoading(false)
    }
  };

  const getErrorMessage = (field) => {
    if (!Array.isArray(errors)) return null;
    const fieldError = errors.find((err) => err.path === field);
    return fieldError?.msg || null;
  };


  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        if (type === 'add') {
          handleAddDate()
        } else {
          handleUpdateDate();
        }
      }
    };

    window.addEventListener("keypress", handleKeyPress);

    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [inputValues]);

  console.log(adventureOptions, "ADV");


  return (
    <Box>
      <Heading
        back={true}
        label={type === "add" ? "Add Date" : "Edit Date"}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <Box width={{ md: "50%", xs: "100%" }}>
          {/* <TextInput
            bgColor={"#f9f9f9"}
            label={"Date"}
            type={"default"}
            placeholder={"Enter Date"}
            value={inputValues.date}
            onChange={(e) => {
              const newValue = e.target.value;
              setInputValues({
                ...inputValues,
                date: newValue,
              });

              setErrors((prevErrors) =>
                prevErrors.filter((err) => err.path !== "date")
              );
              setGeneralError("");
            }}
          /> */}

          <TextInput
            label="Date"
            placeholder="YYYY-MM-DD"
            disabled={true}
            bgColor={"#f9f9f9"}
            value={inputValues.date}
            onClick={handleOpen}
            onChange={(e) => {
              const newValue = e.target.value;
              setInputValues({
                ...inputValues,
                date: newValue,
              });

              setErrors((prevErrors) =>
                prevErrors.filter((err) => err.path !== "date")
              );
              setGeneralError("");
            }}
            fontSize="20px"
          />

          {getErrorMessage("date") && (
            <Box color="red" mb={2}>
              {getErrorMessage("date")}
            </Box>
          )}

          {generalError && (
            <Box color="red" mb={2}>
              {generalError}
            </Box>
          )}

          <Dropdown
            options={adventureOptions}
            label={"Adventure"}
            placeholder="Select Adventure"
            onChange={(e) => setInputValues({ ...inputValues, experience: e.target.value })}
            value={inputValues.experience}
          />

          {getErrorMessage("experienceId") && (
            <Box color="red" mb={2}>
              {getErrorMessage("experienceId")}
            </Box>
          )}


          <CustomButton
            cursor="pointer"
            disabled={loading}
            onClick={type === "add" ? handleAddDate : handleUpdateDate}
          >
            {loading ? <CircularProgress size={25} sx={{ color: "white" }} /> : type === "add" ? "Add Date" : "Update"}
          </CustomButton>
        </Box>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="change-date-title"
        PaperProps={{
          sx: {
            width: "400px",
            maxWidth: "90%",
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle
          id="change-date-title"
          sx={{
            fontSize: "24px",
            fontWeight: 700,
            color: theme.colors.text,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Select Date
          <IconButton
            onClick={handleClose}
            sx={{
              color: theme.colors.text,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div style={{ fontFamily: "Arial, sans-serif" }}>
            <style>
              {`
          .react-calendar {
            width: 100%;
            max-width: 375px;
            margin: 0 auto;
            box-sizing: border-box;
          }

          .react-calendar__navigation button {
            color: #121212;
          }

          .react-calendar__month-view__weekdays {
            font-size: 14px;
            font-weight: 400;
            color: #121212;
          }

          .react-calendar__month-view__weekdays abbr {
            text-decoration: none;
            border: none;
          }

          .react-calendar__tile {
            padding: 5px;
            font-size: 12px;
            text-align: center;
            width: 20px;
            height: 50px;
          }

          .react-calendar__tile--weekend {
            color: inherit;
          }

          .highlight {
            background-color: #FF7900;
            border-radius: 50%;
            width: 20px;
            height: 50px;
          }

          .react-calendar__tile--disabled {
            background-color: transparent !important;
            color: grey !important;
            pointer-events: none;
          }

          .react-calendar__tile--today {
            background-color: #FF7900 !important;
            color: white !important;
            border-radius: 50%;
            font-weight: bold;
          }

          .react-calendar__tile--selected-row {
            background-color: #FF7900 !important;
            color: white !important;
            border-radius: 50%;
            font-weight: bold;
          }

          .react-calendar__navigation button.react-calendar__navigation__label {
            pointer-events: none;
            color: #121212;
            background: none;
            border: none;
          }

          .react-calendar__navigation button.react-calendar__navigation__arrow {
            pointer-events: auto;
          }

          @media (max-width: 375px) {
            .react-calendar {
              max-width: 100%;
            }

            .react-calendar__tile {
              padding: 3px;
              font-size: 10px;
              width: 30px;
              height: 30px;
            }

            .react-calendar__tile--now,
            .react-calendar__tile--now.react-calendar__tile--active,
            .highlight {
              width: 30px;
              height: 30px;
            }

            .react-calendar__month-view__weekdays {
              font-size: 10px;
            }

            .react-calendar__navigation button {
              font-size: 12px;
            }

            .today-grey {
              background-color: #f0f0f0 !important; 
              color: #121212 !important;
              border-radius: 50%;
            }

            .react-calendar__tile--now {
              background: #000; 
            }
          }
          .today-grey {
            background-color: #f0f0f0 !important; 
            color: #121212 !important;
            border-radius: 50%;
          }
        `}
            </style>

            <Calendar
              minDate={today}
              onChange={(date) => handleDateChange(new Date(date))}
              value={selectedDate ? new Date(selectedDate) : today}
              view={calendarView}
              minDetail="year"
              onActiveStartDateChange={({ activeStartDate, view }) => {
                if (view === "decade") {
                  setCalendarView("year");
                } else if (view === "year") {
                  setTimeout(() => {
                    setSelectedDate(activeStartDate);
                    setCalendarView("month");
                  }, 100);
                }
              }}
              tileClassName={({ date }) => {
                const today = new Date();
                today.setHours(0, 0, 0, 0); 
                const selected = selectedDate ? new Date(selectedDate) : null;
              
                if (
                  selected &&
                  date.getFullYear() === selected.getFullYear() &&
                  date.getMonth() === selected.getMonth() &&
                  date.getDate() === selected.getDate()
                ) {
                  return "highlight";
                }
                if (
                  selected && 
                  date.getFullYear() === today.getFullYear() &&
                  date.getMonth() === today.getMonth() &&
                  date.getDate() === today.getDate() &&
                  (selected.getDate() !== today.getDate() || 
                   selected.getMonth() !== today.getMonth() || 
                   selected.getFullYear() !== today.getFullYear())
                ) {
                  return "today-grey"; 
                }
                
                if (
                  !selected && 
                  date.getFullYear() === today.getFullYear() &&
                  date.getMonth() === today.getMonth() &&
                  date.getDate() === today.getDate()
                ) {
                  return "react-calendar__tile--today";
                }
              
                if (date < today) {
                  return "react-calendar__tile--disabled";
                }
              
                return null;
              }}

              next2Label={null}
              prev2Label={null}
            />


          </div>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default CalendarCreation;
